<p-sidebar
  appendTo="body"
  [(visible)]="isSidebarOpened"
  position="bottom"
  [showCloseIcon]="false"
  styleClass="p-sidebar-lg timeline-sidebar"
  [autoZIndex]="true"
  [style]="{height: 'auto' ,left: 0, right: 0, margin: '0 auto', maxHeight: '100vh'}"
  [dismissible]="false"
  [modal]="true"
  [blockScroll]="true"
  (onHide)="onHide.emit()"
>
  <ng-template pTemplate="header">
    <div class="flex justify-content-between align-items-center width-100">
      <button pButton
              icon="pi pi-arrow-left fa-1x" class="p-button-rounded p-button-text p-button-plain"
              pRipple (click)="goBack()"
              *ngIf="isBackButtonVisible"
      ></button>
      <ng-content select="[app-sidebar-header]"></ng-content>
      <button pButton icon="pi pi-times fa-1x" class="p-button-rounded p-button-text p-button-plain" pRipple (click)="hideSidebar($event)"></button>
    </div>
  </ng-template>
  <div class="grid grid-nogutter justify-content-center safe-area-bottom-padding" style="width: 100%">
    <div class="col-12 sm:col-10" [style]="{maxWidth: '900px'}">
      <div class="grid grid-nogutter pt-0 mt-0 px-0 pb-2 flex justify-content-around align-items-center justify-content-center">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
<ng-template pTemplate="footer">
  <ng-content select="[app-sidebar-footer]"></ng-content>
</ng-template>
</p-sidebar>
